import { Typography } from "@mui/material";

export default function PointDetailBoolean({ property, location }) {
  if (property.type !== "boolean") return <></>;
  if (!location[property.key]) return <></>;

  return (
    <>
      <Typography variant="body1" className="title">
        {property.label}
      </Typography>
      <Typography variant="body1" className="value" sx={{ mb: 1 }}>
        Ja
      </Typography>
    </>
  );
}
